import { useEffect, useRef } from 'react'
import StepShell, { Question, Hint } from '../StepShell'

export default function StepSegment({ answers, dispatch, active }) {
  const timeoutRef = useRef(null)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  function pick(segment) {
    dispatch({ type: 'SET_ANSWER', field: 'segment', value: segment })
    // Matches the original's 220ms auto-advance after picking a segment card.
    // Clear any pending timer first so rapid re-picks don't stack multiple
    // ADVANCE dispatches; the reducer's `from` guard is the backstop.
    clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      dispatch({ type: 'ADVANCE', from: 2 })
    }, 220)
  }

  const cardClass = (selected) =>
    `rounded-xl border-[1.5px] bg-white px-[18px] py-5 text-left font-[inherit] transition-colors duration-150 ${
      selected ? 'border-[var(--ink-blue)] bg-[rgba(27,68,224,.04)]' : 'border-[var(--line)] hover:border-[var(--line-2)]'
    }`
  const labelClass = (selected) => `font-mono text-[1.05rem] font-semibold ${selected ? 'text-[var(--ink-blue)]' : 'text-[var(--ink)]'}`

  return (
    <StepShell active={active} step={2}>
      <Question>Are you a startup or an enterprise?</Question>
      <Hint>This just helps us ask the right follow-up questions.</Hint>
      <div className="mt-[18px] grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button type="button" data-segment="startup" className={cardClass(answers.segment === 'startup')} onClick={() => pick('startup')}>
          <div className={labelClass(answers.segment === 'startup')}>Startup</div>
          <div className="mt-2 text-[0.86rem] leading-[1.5] text-[var(--muted)]">Funded and building fast &mdash; pre-seed through Series B+.</div>
        </button>
        <button type="button" data-segment="enterprise" className={cardClass(answers.segment === 'enterprise')} onClick={() => pick('enterprise')}>
          <div className={labelClass(answers.segment === 'enterprise')}>Enterprise</div>
          <div className="mt-2 text-[0.86rem] leading-[1.5] text-[var(--muted)]">Established org sizing dedicated capacity for a team or department.</div>
        </button>
      </div>
    </StepShell>
  )
}
